export default "__VITE_ASSET__d60FwwRI__"